import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import logoC from "../assets/logo.png";
import api from "./api/api";

const ResetPassword = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const token = searchParams.get("token") || "";
	const [password, setPassword] = useState("");
	const [confirm, setConfirm] = useState("");
	const [message, setMessage] = useState(null);
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		if (!token) {
			setMessage({ type: "error", text: "Token mancante. Usa il link ricevuto via email." });
		}
	}, [token]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setMessage(null);
		if (!password || !confirm) {
			setMessage({ type: "error", text: "Inserisci e conferma la nuova password." });
			return;
		}
		if (password !== confirm) {
			setMessage({ type: "error", text: "Le password non coincidono." });
			return;
		}
		if (!token) {
			setMessage({ type: "error", text: "Token non presente. Usa il link corretto." });
			return;
		}
		setIsSubmitting(true);
		try {
			await api.post("/resetPassword/confirm", { token, password });
			setMessage({ type: "success", text: "Password aggiornata. Ora puoi accedere con la nuova password." });
			setTimeout(() => navigate("/login"), 1500);
		} catch (err) {
			const text = err?.response?.data?.message || "Errore nel salvataggio.";
			setMessage({ type: "error", text });
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div
			className="min-h-screen w-full flex items-center justify-center relative overflow-hidden px-4 py-8"
			style={{ background: "linear-gradient(135deg, rgba(39,55,62,0.95) 0%, rgba(35,100,174,0.65) 50%, rgba(141,196,235,0.35) 100%)" }}
		>
			<div className="absolute inset-0 opacity-50" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.08), transparent 25%), radial-gradient(circle at 80% 0%, rgba(141,196,235,0.2), transparent 30%)" }} />
			<div className="relative z-10 w-full max-w-lg">
				<div className="login-card w-full p-8 space-y-6">
					<div className="flex items-center gap-3 text-white justify-center">
						<img className="w-12 h-12" src={logoC} alt="logo" />
						<div>
							<p className="text-sm opacity-80 text-center md:text-left">Reset password</p>
							<p className="text-xl font-semibold text-center md:text-left">Prophet AI</p>
						</div>
					</div>

					<form autoComplete="off" className="space-y-5" onSubmit={handleSubmit}>
						<div className="space-y-2">
							<label htmlFor="password" className="label-text">
								Nuova password
							</label>
							<input
								type="password"
								name="password"
								id="password"
								placeholder="Inserisci la nuova password"
								value={password}
								className="input-text-login"
								required
								onChange={(e) => setPassword(e.target.value)}
							/>
						</div>
						<div className="space-y-2">
							<label htmlFor="confirm" className="label-text">
								Conferma password
							</label>
							<input
								type="password"
								name="confirm"
								id="confirm"
								placeholder="Ripeti la password"
								value={confirm}
								className="input-text-login"
								required
								onChange={(e) => setConfirm(e.target.value)}
							/>
						</div>
						<button type="submit" disabled={isSubmitting} className="button-login">
							{isSubmitting ? "Salvataggio..." : "Imposta password"}
						</button>
						{message && (
							<p className={`text-sm ${message.type === "error" ? "text-red-200" : "text-white"}`}>
								{message.text}
							</p>
						)}
					</form>
				</div>
			</div>
		</div>
	);
};

export default ResetPassword;
